import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/marketing`;

export default {
  async listPromos() {
    let apiUrl = store.state.countrySelected.api;
    let params = {};
    params.lang = store.state.langSelected.langWsp;

    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/promos`, {
        params: params
      });

      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
  // ,

  // async listNews() {
  //   let apiUrl = store.state.countrySelected.api;
  //   let params = {};
  //   params.lang = store.state.langSelected.langWsp;

  //   try {
  //     let resp = await axios.get(`${apiUrl}/${apiPath}/news`, {
  //       params: params
  //     });

  //     return {
  //       data: resp.data,
  //       error: false
  //     };
  //   } catch (error) {
  //     return {
  //       data: error.data,
  //       error: true
  //     };
  //   }
  // }
};
